import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatesSetArg, EventInput, EventSourceInput } from '@fullcalendar/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { DateService } from 'src/app/utils/date/date.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class ReunionService {

  controller: string = "agenda/";

  REUNION_VIGENTE = 1;
  REUNION_CANCELADA_EMPRESA = 2;
  REUNION_CANCELADA_CLIENTE = 3;

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService,
    private formatterService: FormatterService,
    private dateService: DateService,
  ) { }

  insert(reunion: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'agregar-reunion', reunion, this.sesion.headers);
  }

  update(reunion: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'actualizar/' + reunion.id, reunion, this.sesion.headers);
  }

  delete(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + "delete/" + id, this.sesion.headers);
  }

  view(id: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "ver-reunion/" + id, this.sesion.headers);
  }

  selectRango(fechaInicio: string, fechaTermino: string): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `select-rango/?desde=${fechaInicio}&hasta=${fechaTermino}`, this.sesion.headers);
  }

  selectRangoParaAnonimo(sucursalId: string, fechaInicio: string, fechaTermino: string): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `select-rango-para-anonimo/?sucursal_id=${sucursalId}&desde=${fechaInicio}&hasta=${fechaTermino}`, this.sesion.headersAnonimo);
  }

  cancelarEmpresa(reunion: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'cancelar-reunion-empresa/' + reunion.id, reunion, this.sesion.headers);
  }

  actualizarHorariosDisponibles(horarios: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'actualizar-horarios-atencion', horarios, this.sesion.headers);
  }

  horariosAtencion(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'horarios-atencion', this.sesion.headers);
  }

  fechaDisponibleCliente(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'fecha-disponible-cliente', data, this.sesion.headers);
  }

  createReunionAnonimo(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'crear-reunion-anonimo', data, this.sesion.headersAnonimo);
  }

  reunionesAsEventos(reuniones: any[]): EventInput[] {
    return reuniones.map(reunion => ({
      id: reunion.id,
      title: this.formatterService.nombreCompleto(reunion.cliente),
      start: this.dateService.formatUtcString(reunion.fecha_inicio),
      end: this.dateService.formatUtcString(reunion.fecha_termino),
      backgroundColor: this.getBackgroundColor(reunion),
      groupId: 'reunion',
    }));
  }

  getBackgroundColor(reunion: any): string {
    if (reunion.estado !== this.REUNION_VIGENTE) {
      return '#DF4066';
    }

    const dateFechaInicio = new Date(this.dateService.formatUtcString(reunion.fecha_inicio));
    const dateFechaTermino = new Date(this.dateService.formatUtcString(reunion.fecha_termino));
    const now = new Date();

    if ((dateFechaInicio <= now) && (dateFechaTermino > now)) {
      return '#F17D4C';
    }

    if (dateFechaInicio <= now) {
      return '#6C757D';
    }

    return '#5360FF';
  }

  horariosAtencionAEventos(horarios: any[], datesSet: DatesSetArg): EventInput[] {
    const horariosAtencionEventos = [];
    const { start, end } = datesSet;

    for (const horario of horarios) {
      let desde = new Date(this.dateService.formatUtcString(horario.hora_desde));
      let hasta = new Date(this.dateService.formatUtcString(horario.hora_hasta));
      const debeAumentar = desde < start;
      while (!this.dateService.rangoFechasOverlap(desde, hasta, start, end)) {
        this.dateService.agregarQuitarDias(desde, debeAumentar ? 7 : -7);
        this.dateService.agregarQuitarDias(hasta, debeAumentar ? 7 : -7);
      }

      horariosAtencionEventos.push({
        id: horario.id,
        title: '',
        start: desde,
        end: hasta,
        backgroundColor: '#19A96B',
      })
    }

    return horariosAtencionEventos;
  }
}